import {Pagination} from '../../../utils/pagination'
import {ProductReportContext} from '../context'
import useGetProductReport from '../hooks/useGetProductReport'
import ProductReportHeader from '../sections/headers/ProductReportHeader'
import ProductReportTable from '../sections/table/ProductReportTable'

const ProductReport = () => {
  const {
    productData,
    isLoading,
    filters,
    searchValue,
    onSearch,
    onSortingChange,
    pagination,
    onPageChange,
  } = useGetProductReport()

  const contextValue = {
    productData,
    isLoading,
    filters,
    searchValue,
    onSearch,
    onSortingChange,
  }

  return (
    <ProductReportContext.Provider value={contextValue}>
      <ProductReportHeader />
      <ProductReportTable />
      <Pagination pagination={pagination} onPageChange={onPageChange} />
    </ProductReportContext.Provider>
  )
}

export default ProductReport
